/**
 * 新增 编辑
 * @author 3173
 * @description  新增/编辑
 * @Date  2020/9/28
 */
import React, { Component } from 'react';
import { Card, Form } from 'antd'
import { component_tool, framework_tool } from '@/tool'
import { WizTableForm, WizClassifySelectRe, WizAuthority, WizDataAuthSelect } from '@/containers/common';
import '@/styles/containers/online/live/style.less';
import moment from "moment";

let { WizAvatarUpload, ossFileUtils, WizFileUpload } = framework_tool

let {
  WizButton,
  WizSelect,
  WizTooltip,
  WizInput,
  WizIcon,
  WizUpload,
  WizDatePicker,
  WizRow,
  WizCol,
  WizCard,
  WizRadio,
  WizDivider,
  WizCheckbox,
  WizInputNumber,
  Wizmessage,
  WizAlert,
  WizTreeSelect
} = component_tool;
let WizForm = Form
let Item = Form.Item
let Option = WizSelect.Option

const validator = (rule, value, callback) => {
  if (value) {
    if (value.groupId) {
      callback()
      return
    }
    if (value.orgIds && value.orgIds.length) {
      callback()
      return
    }
    if (value.positionIds && value.positionIds.length) {
      callback()
      return
    }
    if (value.positionCategoryIds && value.positionCategoryIds.length) {
      callback()
      return
    }
    if (value.personIds && value.personIds.length) {
      callback()
      return
    }
  }
  callback('请选择直播受众')
}




/**
 * 此组件没有继承WizComponent，因为需要使用Form.create()该组件
 * 继承WizComponent后 form的部分功能缺失了
 * 初步怀疑是WizComponent修改了生命周期的钩子导致的
 * by mll 2020-2-4
 */

class LiveForm extends Component {

  constructor(props) {
    super(props);
    let { initialValue } = props;
    this.state = {
      type: initialValue && initialValue.liveType ? initialValue.liveType : 1,
      wizAuthorityKey: 'wizAuthorityKey',//用于处理wizAuthority组件重置不生效问题
      showNoticeStart: true,
      showNoticeEnd: true
    }
    this.initialValue = props.initialValue ? props.initialValue : {},


      this.clearWizCallBack = [];
  }
componentDidUpdate(p,v){
  console.log(p,'pppppppp')
  console.log(v,'vvvvvv')
  this.initialValue=p.initialValue

}

  /**上传校验 */
  _ossBeforeUpload(file) {
    let result = true;
    // if (file.type.indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') == -1) {
    //   Wizmessage.error('只能上传xlsx文件,请重新选择!');
    //   result = false;
    // }
    this.setState({
      fileId: undefined,
      file: file,
    }, () => {
      //要做的事情
    }
    )
    return result;
  }

  /** 上传的文件显示内容 */
  _fileChildren() {
    let icon = <WizIcon type="loading" style={{ fontSize: 14 }} />
    let fileName = ''
    if (this.state.file && this.state.file.fileOriginalName) {
      icon = <WizIcon type="paper-clip" />;
      fileName = this.state.file.fileOriginalName;
    } else if (this.state.file && this.state.file.name) {
      fileName = this.state.file.name;
    }
    //anticon anticon-loading
    return (
      <>
        <WizButton><WizIcon type="upload" /> 选择文件</WizButton>
        {
          this.state.file ?
            <div class=" ant-upload-list ant-upload-list-text">
              <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-text">
                <div class="ant-upload-list-item-info">
                  {icon}
                  <span class="ant-upload-list-item-name ant-upload-list-item-name-icon-count-2"> {fileName} </span>
                </div>
              </div>
              {/* <WizProgress strokeColor={{ '0%': '#108ee9', '100%': '#87d068', }} status="active" percent={99.9} showInfo={false}/> */}
            </div> : <></>
        }
      </>
    )
  }

  /** ?提示 */
  _renderCheckTips(tips) {
    if (tips) {
      return (
        <WizTooltip title={tips} >
          <WizIcon type='question-circle-o' />
        </WizTooltip>
      )
    }
  }

  /**
   * 表单基础内容
   *  Item hasFeedback 展示校验状态图标
   */
  _base(value) {
    console.log(value, '77777')
    console.log(this.initialValue, 'this.initialValue')
    const { getFieldDecorator } = this.props.form;
    console.log("this.props.checkDateInfo==", this.props.checkDateInfo);
    let personIdList = [];
    let personInfoAuth = this.initialValue.authInfo && this.initialValue.authInfo.personIds;
    let personInfoAuthNew = [];
    if (personInfoAuth && personInfoAuth instanceof Array && personInfoAuth.length > 0) {
      personInfoAuth.forEach(personInfo => {
        const { id } = personInfo;
        personIdList.push(id);
        personInfoAuthNew.push({ key: id, ...personInfo })
      })
    }
    let base01 = [
      <Item label="直播名称">
        {getFieldDecorator('name', {
          rules: [{ required: true, message: '请输入直播名称' }],
          initialValue: this.initialValue.name,
        })(<WizInput maxlength={33} placeholder='请输入直播名称,最多输入33个字' />)}
      </Item>,
      <Item label="开播时间">
        {getFieldDecorator('startDate', {
          rules: [{ required: true, message: '请选择开播时间', }],
          initialValue: this.initialValue.startDate,
          onChange: (form, value, label, extra) => {
            if (value) {
              this.setState({
                showNoticeStart: true
              })
            } else {
              this.setState({
                showNoticeStart: false
              })
            }
            let startDate = value;
            let endDate = this.props.form.getFieldValue('endDate') ? moment(this.props.form.getFieldValue('endDate')).format('YYYY-MM-DD HH:mm:ss') : undefined;
            let ownerId = this.initialValue.ownerId;
            // type ： 0:zoom资源帐户；1：中目资源帐户
            // liveType：4 远程认证 5 直播课堂 6远程评估
            let type = this.initialValue.liveType === 5 || this.initialValue.liveType === 4 ? 2 : this.initialValue.liveType === 6 ? 1 : undefined;
            if ((type === 2 || type === 1) && startDate && endDate && this.props.checkMeetingDate) {
              startDate = startDate + ":00"
              this.props.checkMeetingDate(startDate, endDate, ownerId, type)
            }
          },
        })(<WizDatePicker key='startDate' showTime placeholder="请选择开播时间" format="YYYY-MM-DD HH:mm:ss" />)}
      </Item>,
      // <Item label="结束时间">
      //   {getFieldDecorator('endDate', {
      //     rules: [{ required: true, message: '请选择结束时间', }],
      //     initialValue: this.initialValue.endDate,
      //     onChange : (form,value,label,extra)  => {
      //       let endDate = value;
      //       let startDate = this.props.form.getFieldValue('startDate') ? moment(this.props.form.getFieldValue('startDate')).format('YYYY-MM-DD HH:mm:ss') : undefined;
      //       let ownerId = this.initialValue.ownerId;
      //       // type ： 0:zoom资源帐户；1：中目资源帐户
      //       // liveType：4 远程认证 5 直播课堂 6远程评估
      //       let type = this.initialValue.liveType === 5 || this.initialValue.liveType === 4 ? 0 : this.initialValue.liveType ===6 ? 1 : undefined;
      //       if((type===0 || type===1) && startDate && endDate && this.props.checkMeetingDate){
      //         endDate = endDate+":00"
      //         this.props.checkMeetingDate(startDate,endDate,ownerId,type)
      //       }
      //     },
      //   })(<WizDatePicker key='endDate' showTime placeholder="请选择结束时间" format="YYYY-MM-DD HH:mm" 	/>)}
      // </Item>,


      <Item label="结束时间" layout="inline" colon={false}>{getFieldDecorator('endDate', {
        rules: [{ required: true, message: '请选择结束时间', }],
        initialValue: this.initialValue.endDate,
        onChange: (form, value, label, extra) => {
          if (value) {
            this.setState({
              showNoticeEnd: true
            })
          } else {
            this.setState({
              showNoticeEnd: false
            })
          }
          let endDate = value;
          let startDate = this.props.form.getFieldValue('startDate') ? moment(this.props.form.getFieldValue('startDate')).format('YYYY-MM-DD HH:mm:ss') : undefined;
          let ownerId = this.initialValue.ownerId;
          // type ： 0:zoom资源帐户；1：中目资源帐户
          // liveType：4 远程认证 5 直播课堂 6远程评估
          let type = this.initialValue.liveType === 5 || this.initialValue.liveType === 4 ? 2 : this.initialValue.liveType === 6 ? 1 : undefined;
          if ((type === 2 || type === 1) && startDate && endDate && this.props.checkMeetingDate) {
            endDate = endDate + ":00"
            this.props.checkMeetingDate(startDate, endDate, ownerId, type)
          }
        },
      })(<WizDatePicker key='endDate' showTime placeholder="请选择结束时间" format="YYYY-MM-DD HH:mm:ss" />)}
        {
          this.props.checkDateInfo && this.state.showNoticeStart && this.state.showNoticeEnd ?
            <Item style={{ marginBottom: 0, display: 'inline-block', marginLeft: '5%', }}>
              <font style={{ 'color': 'red' }}>剩余资源提醒:{this.props.checkDateInfo} </font>
            </Item> :
            undefined
        }
      </Item>,

      // <Item label="结束时间" layout="inline" style={{width: '100%' }}>
      // <Item colon={false} style={{ marginBottom: 0, display: 'inline-block', width: '30%' }}>{getFieldDecorator('endDate', {
      //           rules: [{ required: true, message: '请选择结束时间', }],
      //           initialValue: this.initialValue.endDate,
      //           onChange : (form,value,label,extra)  => {
      //             if(value){
      //               this.setState({
      //                 showNoticeEnd : true
      //               })
      //             }else{
      //               this.setState({
      //                 showNoticeEnd : false
      //               })
      //             }
      //             let endDate = value;
      //             let startDate = this.props.form.getFieldValue('startDate') ? moment(this.props.form.getFieldValue('startDate')).format('YYYY-MM-DD HH:mm:ss') : undefined;
      //             let ownerId = this.initialValue.ownerId;
      //             // type ： 0:zoom资源帐户；1：中目资源帐户
      //             // liveType：4 远程认证 5 直播课堂 6远程评估
      //             let type = this.initialValue.liveType === 5 || this.initialValue.liveType === 4 ? 2 : this.initialValue.liveType ===6 ? 1 : undefined;
      //             if((type===2 || type===1) && startDate && endDate && this.props.checkMeetingDate){
      //               endDate = endDate+":00"
      //               this.props.checkMeetingDate(startDate,endDate,ownerId,type)
      //             }
      //           },
      //         })(<WizDatePicker key='endDate' showTime placeholder="请选择结束时间" format="YYYY-MM-DD HH:mm:ss" 	/>)}</Item>
      // {this.props.checkDateInfo && this.state.showNoticeStart && this.state.showNoticeEnd ?<Item  style={{ marginBottom: 0, display: 'inline-block', marginLeft: '5%', }}
      //   >
      //   <font style={{'color':'red'}}>剩余资源提醒:{this.props.checkDateInfo} </font>
      // </Item> : undefined }
      // </Item>,


      // this.props.checkDateInfo?<div style={{'color': 'red'}}>剩余资源提醒:{this.props.checkDateInfo}</div>:null,

      <Item label="直播类型" >
        {getFieldDecorator('liveType', {
          initialValue: this.initialValue.liveType ? this.initialValue.liveType : 1
        })(
          <WizRadio.Group disabled={(this.initialValue.id != null && this.initialValue.id != undefined) ? true : false}
            onChange={(e) => {
              this.setState({ type: e.target.value, wizAuthorityKey: 'wizAuthorityKey' + new Date().getTime() })
              this.props.form.setFieldsValue({
                authCmd: {},
              })
            }} >
            <WizRadio value={1}>视频直播</WizRadio>
            {/* <WizRadio value={2}>互动直播</WizRadio>
            <WizRadio value={3}>点播</WizRadio> */}
            {/*<WizRadio value={4}>远程认证</WizRadio>*/}
            {/*<WizRadio value={5}>直播课堂</WizRadio>*/}
            {/*<WizRadio value={6}>远程评估</WizRadio>*/}
            {/*<WizRadio value={7}>企微会议</WizRadio>*/}
            {/*<WizRadio value={8}>企微直播</WizRadio>*/}
          </WizRadio.Group>
        )}
      </Item>,
    ];
    let zoomBase = [];
    if (this.state.type != null && (this.state.type === 5 || this.state.type === 6)) {
      zoomBase = this._zoomInteractLive();
    }
    let base02 = [
      <Item label="观看类型" >
        {getFieldDecorator('watchType', {
          initialValue: this.initialValue.watchType ? this.initialValue.watchType : 1
        })(
          <WizRadio.Group>
            <WizRadio value={1}>横屏</WizRadio>
            <WizRadio value={2}>竖屏</WizRadio>
          </WizRadio.Group>
        )}
      </Item>,
      this.state.type == 1 ?
        // <Item label="视频直播类型" >
        getFieldDecorator('liveVideoType', {
          initialValue: this.initialValue && this.initialValue.liveVideoType !== null && this.initialValue.liveVideoType !== undefined
            && this.initialValue.liveVideoType !== 'null' && this.initialValue.liveVideoType === 4 ? 4 : 1
        })/*(
            <WizRadio.Group disabled={(this.initialValue.id!=null && this.initialValue.id!=undefined) ? true : false}>
              <WizRadio value={1}>大型直播</WizRadio>
              <WizRadio value={4}>虚拟直播</WizRadio>
            </WizRadio.Group>
          )*/ : null
      // </Item>: <></>
      ,
      this.state.type != 4&&!this.initialValue.liveCategoryId ?
        <Item label="直播分类"
        >

          {getFieldDecorator('liveCategoryId', {
            rules: [{ type: 'array' }, { required: true, message: '请选择直播分类' }],
            initialValue: this.initialValue.liveCategoryId ? [this.initialValue.liveCategoryId] : [],
          })(
            <WizClassifySelectRe
            // key={this.initialValue.categoryInfo?.length>0?this.initialValue.categoryInfo[0]?.key:'' }
                          returnKey={true}
              apiProps={{ type: 9, state: 1 }}
              // initSelects={[{key: 161, title: '普通直播'}]}
              initSelects={this.initialValue.categoryInfo ? this.initialValue.categoryInfo : []}
              wizTreeSelectListProps={{
                itemProps: {
                  icon: 'unordered-list',
                  title: '直播分类',
                  tips: '请选择直播分类'
                },
                multiple: false,
                treeCheckable: false,
                checkable: false,
                showSelectList: true,
                treeProps: { checkStrictly: true }
              }}
              onClearWiz={this._onClearWiz.bind(this)} />
            // <WizTreeSelect/>
          )}
        </Item> : <></>,
        //为快速解决直播分类不回显问题，组件仅接收初始化第一次的值，后续更新不会在WizClassifySelectRe组件内更新
        this.state.type != 4&&this.initialValue.categoryInfo?.length>0 ?
        <Item label="直播分类"
        >

          {getFieldDecorator('liveCategoryId', {
            rules: [{ type: 'array' }, { required: true, message: '请选择直播分类' }],
            initialValue: this.initialValue.liveCategoryId ? [this.initialValue.liveCategoryId] : [],
          })(
            <WizClassifySelectRe
            // key={this.initialValue.categoryInfo?.length>0?this.initialValue.categoryInfo[0]?.key:'' }
                          returnKey={true}
              apiProps={{ type: 9, state: 1 }}
              // initSelects={[{key: 161, title: '普通直播'}]}
              initSelects={this.initialValue.categoryInfo ? this.initialValue.categoryInfo : []}
              wizTreeSelectListProps={{
                itemProps: {
                  icon: 'unordered-list',
                  title: '直播分类',
                  tips: '请选择直播分类'
                },
                multiple: false,
                treeCheckable: false,
                checkable: false,
                showSelectList: true,
                treeProps: { checkStrictly: true }
              }}
              onClearWiz={this._onClearWiz.bind(this)} />
            // <WizTreeSelect/>
          )}
        </Item> : <></>,
    ]
    let authBase = [];
    if (this.state.type != null && this.state.type === 4) {
      //直播课堂、远程评估 多选择人  不能超过25人
      authBase = [
        <Item label="直播受众" required >
          {getFieldDecorator('authCmd', {
            rules: [{ required: true, message: '请选择直播受众', }],
            initialValue: personIdList,
          })(<WizTableForm key={this.state.wizAuthorityKey}
            {...WizTableForm.Config.user(this, { apiParams: { state: 1 } })} selectType={"radio"} onClearWiz={this._onClearWiz.bind(this)}
            initRows={personInfoAuthNew} />)}
        </Item>
      ];
    } else if (this.state.type != null && (this.state.type === 5 || this.state.type === 6)) {
      //远程认证 单选人
      authBase = [
        <Item label="直播受众" required >
          {getFieldDecorator('authCmd', {
            rules: [{ required: true, message: '请选择直播受众', }],
            initialValue: personIdList,
          })(<WizTableForm key={this.state.wizAuthorityKey}
            {...WizTableForm.Config.user(this, { apiParams: { state: 1 } })} onClearWiz={this._onClearWiz.bind(this)}
            initRows={personInfoAuthNew} />)}
        </Item>
      ]
    } else {
      authBase = [
        <Item label="直播受众" >
          {getFieldDecorator('authCmd', {
            initialValue: Object.assign({}, this.initialValue.authInfo),
            rules: [{ required: true, validator }],
          })(
            <WizDataAuthSelect />
          )}
        </Item>
      ]
    }
    let allBase = [...base01, ...zoomBase, ...base02, ...authBase];
    return allBase
  }


  /**
   *  zoom类型的直播
   *  Item hasFeedback 展示校验状态图标
   */
  _zoomInteractLive() {
    const formItemTitleLayout = {
      wrapperCol: { span: 16, offset: 4 },
    };
    const { getFieldDecorator } = this.props.form;
    let items = [
      <Item label="直播设置">
        <WizButton title="恢复默认设置" size='small' onClick={e => {
          this._changeInteractLiveValue()
        }}>恢复默认设置</WizButton>
      </Item>,
      <Item {...formItemTitleLayout}>
        <Card>
          <WizRow className='row-live-form-style' style={{ marginTop: 10, marginBottom: 10 }}>
            <WizCol span={5} className='item-form-title' style={{ textAlign: 'right' }}>{'是否自动录制：'}</WizCol>
            <WizCol span={6} className='item-content'>
              {getFieldDecorator('autoRecording', {
                initialValue: this.initialValue.autoRecording ? this.initialValue.autoRecording : 0
              })(
                <WizRadio.Group>
                  <WizRadio value={1}>是</WizRadio>
                  <WizRadio value={0}>否</WizRadio>
                </WizRadio.Group>
              )}
              <WizTooltip title="是否系统自动录制视频">
                <WizIcon type="question-circle-o" />
              </WizTooltip>
            </WizCol>
            <WizCol span={6} className='item-form-title' style={{ textAlign: 'right' }}
              offset={1}>{'开播人视频：'}</WizCol>
            <WizCol span={6} className='ant-col ant-col-17 ant-form-item-control-wrapper item-content'>
              {getFieldDecorator('hostVideo', {
                initialValue: this.initialValue.hostVideo ? this.initialValue.hostVideo : 0
              })(
                <WizRadio.Group>
                  <WizRadio value={1}>是</WizRadio>
                  <WizRadio value={0}>否</WizRadio>
                </WizRadio.Group>
              )}
              <WizTooltip title="开播人进入课堂时是否打开摄像头">
                <WizIcon type="question-circle-o" />
              </WizTooltip>
            </WizCol>
          </WizRow>
          <WizRow className='row-live-form-style' style={{ marginTop: 10, marginBottom: 10 }}>
            <WizCol span={5} className='item-form-title' style={{ textAlign: 'right' }}>{'学员视频：'}</WizCol>
            <WizCol span={6} className='ant-col ant-col-17 ant-form-item-control-wrapper item-content'>
              {getFieldDecorator('participantVideo', {
                initialValue: this.initialValue.participantVideo ? this.initialValue.participantVideo : 0
              })(
                <WizRadio.Group>
                  <WizRadio value={1}>是</WizRadio>
                  <WizRadio value={0}>否</WizRadio>
                </WizRadio.Group>
              )}
              <WizTooltip title="学员进入课堂时是否打开摄像头">
                <WizIcon type="question-circle-o" />
              </WizTooltip>
            </WizCol>
            <WizCol span={6} className='item-form-title' style={{ textAlign: 'right' }}
              offset={1}>{'是否开启等候室：'}</WizCol>
            <WizCol span={6} className='ant-col ant-col-17 ant-form-item-control-wrapper item-content'>
              {getFieldDecorator('waitingRoom', {
                initialValue: this.initialValue.waitingRoom ? this.initialValue.waitingRoom : 0
              })(
                <WizRadio.Group>
                  <WizRadio value={1}>是</WizRadio>
                  <WizRadio value={0}>否</WizRadio>
                </WizRadio.Group>
              )}
              <WizTooltip title="等候室,学员进入课堂时，将他们放在等候室中，并要求开播人单独接受。启用等候室会自动禁用允许学员先进入课堂的设置">
                <WizIcon type="question-circle-o" />
              </WizTooltip>
            </WizCol>
          </WizRow>
          <WizRow className='row-live-form-style' style={{ marginTop: 10, marginBottom: 10 }}>
            <WizCol span={5} className='item-form-title' style={{ textAlign: 'right' }}>{'进入静音：'}</WizCol>
            <WizCol span={6} className='ant-col ant-col-17 ant-form-item-control-wrapper item-content'>
              {getFieldDecorator('muteUponEntry', {
                initialValue: this.initialValue.muteUponEntry ? this.initialValue.muteUponEntry : 0
              })(
                <WizRadio.Group>
                  <WizRadio value={1}>是</WizRadio>
                  <WizRadio value={0}>否</WizRadio>
                </WizRadio.Group>
              )}
              <WizTooltip title="学员进入课堂时是否默认静音">
                <WizIcon type="question-circle-o" />
              </WizTooltip>
            </WizCol>
            <WizCol span={6} className='item-form-title' style={{ textAlign: 'right' }}
              offset={1}>{'学员先进入课堂：'}</WizCol>
            <WizCol span={6} className='ant-col ant-col-17 ant-form-item-control-wrapper item-content'>
              {getFieldDecorator('joinBeforeHost', {
                initialValue: this.initialValue.joinBeforeHost ? this.initialValue.joinBeforeHost : 0
              })(
                <WizRadio.Group>
                  <WizRadio value={1}>是</WizRadio>
                  <WizRadio value={0}>否</WizRadio>
                </WizRadio.Group>
              )}
              <WizTooltip title="当老师未进入课堂时,是否允许学员先进入">
                <WizIcon type="question-circle-o" />
              </WizTooltip>
            </WizCol>
          </WizRow>
        </Card>
      </Item>
    ]
    return items
  }



  /**点播的数据 */
  _onDeman() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Item label="视频文件" >
        {getFieldDecorator('videoFile', {
          rules: [{ required: true, message: '请上传视频文件' }],
          initialValue: (this.initialValue && this.initialValue.videoFile) ? [
            ossFileUtils.getOssFile(
              this.initialValue.videoFile, this.initialValue.videoFileName, this.initialValue.videoFileMimeType, this.initialValue.videoFileSize, this.initialValue.videoFileUri,
            )
          ] : [],
        })(
          <WizFileUpload
            accept={'.mp4'}
            beforeUpload={this._ossBeforeUpload.bind(this)}
            children={this._fileChildren()}
            showUploadList={false}
            uploadType={'system'}
          />
        )}
      </Item>)
  }

  /**直播的数据 */
  _liveBroadcast() {
    const { getFieldDecorator } = this.props.form;
    const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1, roleConfig: "presenterRole" } })
    let { initialValue } = this.props
    //personInfo传值未再this.initialValue中接收到，故直接从this.props
    let items = [
      <Item label="开播人" required >
        {getFieldDecorator('hostId', {
          rules: [{ required: true, message: '请选择开播人', }],
          initialValue: this.initialValue.hostId,
        })(<WizTableForm {...userConfig} selectType={"radio"} title="选择开播人" onClearWiz={this._onClearWiz.bind(this)}
          disabled={(this.initialValue.state == 3 || this.initialValue.state == 4) ? true : false} initRows={initialValue ? initialValue.personInfo : []} />)}
      </Item>,
      <Item label="主讲人" >
        {getFieldDecorator('speaker', {
          initialValue: this.initialValue.speaker
        })(
          <WizInput maxLength={50} placeholder={'请输入主讲人'} />
        )}
      </Item>,
      <Item label="是否可回看" >
        {getFieldDecorator('lookingBack', {
          initialValue: this.initialValue.lookingBack || this.initialValue.lookingBack == 0 ? this.initialValue.lookingBack : 1
        })(
          <WizRadio.Group>
            <WizRadio value={1}>是</WizRadio>
            <WizRadio value={0}>否</WizRadio>
          </WizRadio.Group>
        )}
      </Item>
    ];
    return items
  }

  /**
   * 企微会议/企微直播
   */
  _qyWeiXinLive() {
    const { getFieldDecorator } = this.props.form;
    const userConfig = WizTableForm.Config.user2(this, { apiParams: { state: 1 } })

    return (
      <Item label="开播人" required >
        {getFieldDecorator('hostId', {
          rules: [{ required: true, message: '请选择开播人', }],
          initialValue: this.initialValue.hostId,
        })(<WizTableForm {...userConfig} selectType={"radio"} key={'qy-weixin-live-' + this?.state?.type} title="选择开播人" onClearWiz={this._onClearWiz.bind(this)} initRows={this.initialValue.personInfo ? this.initialValue.personInfo : []} />)}
      </Item>
    )
  }

  /**
    * 拓展属性
    */
  _ext = () => {
    if (this.state.type === 3) {
      return this._onDeman();
    } else if (this.state.type === 1 || this.state.type === 2 || this.state.type === 4 || this.state.type === 5 || this.state.type === 6) {
      return this._liveBroadcast();
    } else if ([7, 8].indexOf(this.state.type) !== -1) {
      return this._qyWeiXinLive();
    }
    return null;
  }

  _ext2() {
    const { getFieldDecorator } = this.props.form;
    return (
      <>
        <Item
          label={<span>
            直播封面&nbsp;
            <WizTooltip title="请上传大小不超过200KB,图片尺寸建议1600*800">
              <WizIcon type="question-circle-o" />
            </WizTooltip>
          </span>
          }>
          {getFieldDecorator('img', {
            initialValue: (this.initialValue && this.initialValue.img) ? [
              // ossFileUtils.getOssFile(
              //   this.initialValue.img, this.initialValue.fileName, this.initialValue.fileMimeType, this.initialValue.fileSize, this.initialValue.fileUri,// fileId: this.initialValue.img
              // )
              { fileId: this.initialValue.img }
            ] : [],
          })(
            <WizAvatarUpload
              accept={'.jpg, .jpeg, .png'}
              listType={'picture-card'}
              aspectRatio={2 / 1}
              beforeUpload={(file) => {
                let result = true;
                const isLt1M = file.size / 1024 / 1024 < 0.195;
                if (file.type.indexOf('image/') == -1) {
                  Wizmessage.error('只能上传图片类型,请重新选择!');
                  result = false;
                } else if (!isLt1M) {
                  Wizmessage.error('图片不得超过200k!');
                  result = false;
                }
                return result;
              }}
            />
          )}
        </Item>
        <Item label="是否允许匿名互动" >
          {getFieldDecorator('anonymous', {
            initialValue: this.initialValue.anonymous == 1 ? 1 : 0
          })(
            <WizRadio.Group>
              <WizRadio value={1}>是</WizRadio>
              <WizRadio value={0}>否</WizRadio>
            </WizRadio.Group>
          )}
        </Item>
        <Item label="介绍" >
          {getFieldDecorator('intro', {
            initialValue: this.initialValue.intro
          })(
            <WizInput.TextArea rows={4} maxLength={200} placeholder={'请输入介绍'} />
          )}
        </Item>
      </>
    )
  }


  /**
   * 表单提交按钮
   */
  _submit() {
    return (
      <Item wrapperCol={{ span: 12, offset: 6 }}>
        <WizRow>
          <WizCol span={24} style={{ textAlign: 'center' }}>
            <WizButton style={{ marginLeft: 20 }} title="保存" type="primary" htmlType="submit">保存</WizButton>
            <WizButton style={{ marginLeft: 20 }} onClick={this.handleReset}>重置</WizButton>
          </WizCol>
        </WizRow>
      </Item>
    )
  }

  /**
   * 处理表单提交事件
   */
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.props.onSubmit) {
          this.props.onSubmit(values);
        }
      }
    });
  };

  /**
   * 重置表单
   */
  handleReset = () => {
    this.props.form.resetFields();
    this.clearWizCallBack.forEach(callback => {
      callback && callback()
    })
    let type = this.initialValue && this.initialValue.type ? this.initialValue.type : undefined;
    this.setState({
      type: type,
      wizAuthorityKey: 'wizAuthorityKey' + new Date().getTime()
    })
  };

  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }

  /**
   *
   * 设置直播附属信息值,未传则全部设置默认值
   */
  _changeInteractLiveValue = () => {
    this.props.form.setFieldsValue({
      autoRecording: 0,
      hostVideo: 0,
      participantVideo: 0,
      waitingRoom: 0,
      muteUponEntry: 0,
      joinBeforeHost: 0,
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { title } = this.props;
    this.initialValue = this.props.initialValue
    console.log(this.initialValue, 'this.initialValue888')
    console.log(this.props.initialValue, 'props.initialValue9999')
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    return (
      <WizCard title={title} icon='0'>
        <WizForm
          key={this.props.formKey}
          {...formItemLayout}
          onSubmit={this.handleSubmit}
        >
          {this._base(this.props.initialValue)}
          {this._ext()}
          {this._ext2()}
          {this._submit()}
        </WizForm>
      </WizCard>
    )

  }
}

export default WizForm.create()(LiveForm);


